import { usePaginatedFarms } from '@cibo/landmanager'
import { LinearProgress } from '@mui/material'
import { DataGridPro, ExtendedDataGridProProps } from '@cibo/ui'

type PaginatedFarmsTableProps = Omit<ExtendedDataGridProProps, 'rows'>

export const PaginatedFarmsTable = ({
  autoHeight = true,
  components,
  loading,
  ...datagridProps
}: PaginatedFarmsTableProps) => {
  const farms = usePaginatedFarms()
  const rows = farms.data ? farms.data.items : []

  return (
    <DataGridPro
      autoHeight={autoHeight}
      components={{
        LoadingOverlay: () => <LinearProgress sx={{ marginBottom: -0.5 }} />,
        ...components,
      }}
      loading={farms.isFetching || loading}
      rows={rows}
      {...datagridProps}
    />
  )
}
